import { computed, EventEmitter, Signal, signal, WritableSignal } from '@angular/core';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { faRuler } from '@fortawesome/pro-regular-svg-icons';
import { TranslocoService } from '@jsverse/transloco';
import { Map } from 'maplibre-gl';

import { AbstractMapControl } from '@connect-services/client/components/map/abstract-map-control';
import { ViewParam } from '@connect-services/client/components/map/map.component';
import { ControlButtonStyle } from '@connect-services/client/services/map-control.service';
import { MapModal, MapModalService } from '@connect-services/client/services/map-modal.service';

export class MeasurementToolControl extends AbstractMapControl {
    public measurementToolToggled: EventEmitter<boolean> = new EventEmitter<boolean>();

    private readonly isActive: WritableSignal<boolean> = signal(false);

    private readonly viewParam: Signal<ViewParam> = computed(() => {
        return this.isActive()
            ? {
                  icon: faRuler,
                  labelTranslation: 'cancel',
              }
            : {
                  icon: faRuler,
                  labelTranslation: 'measureDistances',
              };
    });

    public constructor(
        map: Map,
        private readonly controlButtonStyle: ControlButtonStyle,
        private readonly mapModalService: MapModalService,
        private readonly translocoService: TranslocoService,
    ) {
        super();
        this.map = map;
    }

    protected initButton(): void {
        this.setupButton('measurement-tool-control', () => this.handleControl(), ['measurement-tool-control']);
        this.refreshButton();
    }

    private handleControl(): void {
        if (!this.map) {
            return;
        }

        this.isActive.set(!this.isActive());

        this.refreshButton();
        this.toggleShapeExportControl(this.isActive());

        this.toggleMapModalMeasurement(this.isActive());

        this.measurementToolToggled.emit(this.isActive());

        this.map.getCanvas().style.cursor = this.isActive() ? 'crosshair' : '';
    }

    private refreshButton(): void {
        this.setButtonIcon(
            icon(this.viewParam().icon, {
                styles: this.controlButtonStyle,
            }).html[0],
        );

        this.setButtonState({
            isActive: this.isActive(),
        });

        this.setButtonTitle(this.translocoService.translate(this.viewParam().labelTranslation));
    }

    private toggleMapModalMeasurement(isActive: boolean): void {
        if (isActive) {
            this.mapModalService.open(MapModal.MEASUREMENT);

            return;
        }

        this.mapModalService.close(MapModal.MEASUREMENT);
    }

    private toggleShapeExportControl(disabled: boolean): void {
        const shapeExportControl = document.getElementById('shape-export-control') as HTMLButtonElement | null;

        if (!shapeExportControl) {
            return;
        }

        shapeExportControl.disabled = disabled;
    }
}
